import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { LinkButton } from 'shared/mui/Buttons';
import { CardTable } from 'shared/mui/Card/CardTableNew/CardTable';
import { TableRowWrapper } from 'shared/mui/Table/TableRowWrapperNew/TableRowWrapper';
import { DateTimeField, FunctionField } from 'shared/react-admin/Fields';
import { Company } from 'types/embedded/company';

type Props = {
  onClose?: VoidFunction;
};

export const CompanyShowDialogTable = ({ onClose }: Props) => {
  const translate = useTypedTranslate();

  return (
    <CardTable tableBodyProps={{ sx: { '& td': { width: '172px' } } }}>
      <TableRowWrapper label={translate('app.table.merchantsAmount')}>
        <FunctionField
          onClick={() => onClose?.()}
          render={({ merchantCount, ['@id']: id }: Company) => {
            return (
              <LinkButton
                label={String(merchantCount)}
                pathParams={{
                  resource: 'merchants',
                  type: 'list',
                }}
                queryParams={{
                  filter: { companies: [id] },
                }}
              />
            );
          }}
          source="merchantCount"
        />
      </TableRowWrapper>
      <TableRowWrapper label={translate('app.table.createdAt')}>
        <DateTimeField inline source="createdAt" />
      </TableRowWrapper>
      <TableRowWrapper label={translate('app.table.lastUpdatedAt')}>
        <DateTimeField inline source="updatedAt" />
      </TableRowWrapper>
    </CardTable>
  );
};
